<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" title="详情" width="800px" :close-on-click-modal="false" top="2vh" :close-on-press-escape="false">
    <div class="detail-content">
      <el-form :model="dataForm" :rules="dataRule" :size="btnSize" ref="dataForm" label-position='right' label-width="100px" v-loading="dialogLoading">
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="业主公司">
              {{ dataForm.proprietorCompanyName }}
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="物业公司">
              {{ dataForm.propertyCompanyName }}
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="办理人">
              {{ dataForm.proprietorTransactorNickname }}
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="办理人">
              {{ dataForm.propertyTransactorNickname }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="合同时间">
              {{ dataForm.startTime + '-' + dataForm.endTime }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <h3 class="title">租用场地</h3>
            <el-table ref="table" class="simple-table" :data="siteList" highlight-current-row fit border >
              <el-table-column prop="name" label="场地名称" align="left" min-width="160" show-overflow-tooltip></el-table-column>
              <el-table-column prop="place" label="位置" align="left" min-width="160" show-overflow-tooltip></el-table-column>
              <el-table-column prop="area" label="面积" align="left" min-width="160" show-overflow-tooltip></el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24">
            <h3 class="title">合同能源计价表</h3>
            <div class="energy-pricing" v-for="(item, idx) in energyPricing" :key="idx">
              <el-col :span="12">
                <el-form-item label="能源类型">
                  {{ handleEnergyTypeFormat(item.energyType) }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="计价模型">
                  {{ handleModelormat(item.energyType, item.model) }}
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="(item.energyType === 1 && item.model === 1)">
                <div class="info">
                  <div class="info-item">
                    <p class="item-text-header">时段：峰期</p>
                    <p class="item-text-second">价格 {{item.params.unitPrice.peak}}</p>
                    <p class="item-text-three">时间</p>
                    <div class="time-text">
                      <p class="item-text-four" v-for="(time, i) in item.params.timeSegment.peak" :key="i">{{ time.startTime + '-' + time.endTime }}</p>
                    </div>
                  </div>
                  <div class="info-item">
                    <p class="item-text-header">时段：平期</p>
                    <p class="item-text-second">价格 {{item.params.unitPrice.plain}}</p>
                    <p class="item-text-three">时间</p>
                    <div class="time-text">
                      <p class="item-text-four" v-for="(time, i) in item.params.timeSegment.plain" :key="i">{{ time.startTime + '-' + time.endTime }}</p>
                    </div>
                  </div>
                  <div class="info-item">
                    <p class="item-text-header">时段：谷期</p>
                    <p class="item-text-second">价格 {{item.params.unitPrice.sharp}}</p>
                    <p class="item-text-three">时间</p>
                    <div class="time-text">
                      <p class="item-text-four" v-for="(time, i) in item.params.timeSegment.sharp" :key="i">{{ time.startTime + '-' + time.endTime }}</p>
                    </div>
                  </div>
                  <div class="info-item">
                    <p class="item-text-header">时段：尖期</p>
                    <p class="item-text-second">价格 {{item.params.unitPrice.valley}}</p>
                    <p class="item-text-three">时间</p>
                    <div class="time-text">
                      <p class="item-text-four" v-for="(time, i) in item.params.timeSegment.valley" :key="i">{{ time.startTime + '-' + time.endTime }}</p>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="24" v-else-if="(item.energyType === 1 && item.model === 3)">
                <div>
                  <p class="title">价格</p>
                  <el-table ref="table" class="simple-table" :data="item.params" highlight-current-row fit border >
                    <el-table-column prop="thresholdValue" label="阈值" align="left" min-width="160" show-overflow-tooltip :formatter='handleThresholdValueFormat'></el-table-column>
                    <el-table-column prop="unitPrice" label="单价" align="left" min-width="160" show-overflow-tooltip></el-table-column>
                  </el-table>
                </div>
              </el-col>
              <el-col v-else :span="12">
                <el-form-item label="价格">
                  {{ item.params.unitPrice }}
                </el-form-item>
              </el-col>
            </div>
          </el-col>
          <el-col :span="24">
            <h3 class="title">合同基本费用表</h3>
            <el-table ref="table" class="simple-table" :data="basicCharges" highlight-current-row fit border >
              <el-table-column prop="name" label="费用名称" align="left" min-width="160" show-overflow-tooltip></el-table-column>
              <el-table-column prop="value" label="费用" align="left" min-width="160" show-overflow-tooltip></el-table-column>
            </el-table>
            <el-col :span="12">
              <el-form-item label="合同利润抽成">
                {{ dataForm.takePercentageFromProfit }}%
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Detail',
  data () {
    return {
      btnSize: 'small',
      dialogLoading: false,
      visible: false,
      dataForm: {},
      basicCharges: [],
      energyPricingObject: {
        energyType: 1,
        model: 1,
        unitPrice: '',
        ladder: [
          { thresholdValue: '', unitPrice: '' }
        ],
        point: [
          { name: '峰', type: 'peak', }
        ],
        params: ''
      },
      energyPricing: [],
      energyTypes: [
        { label: '电', value: 1 },
        { label: '水', value: 2 },
        { label: '天然气', value: 3 },
        { label: '柴油', value: 4 }
      ]
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init (row) {
      this.visible = true
      this.$nextTick(() => {
        console.log(row)
        this.dataForm = Object.assign({}, row)
        // this.energyPricing = this.dataForm.energyPricingConfig
        this.energyPricing = this.dataForm.energyPricingConfig.map((item) => {
          return {
            ...item,
            params: JSON.parse(item.params)
            // params: this.handleParams(item)
          }
        })
        this.siteList = this.dataForm.areas
        console.log(this.energyPricing)
        this.basicCharges = this.dataForm.basicCharges
      })
    },
    handleParams (params) {
      if (params.energyType === 1 && params.model === 1) {
        console.log(JSON.parse(params.params))
        return JSON.parse(params.params)
      } else {
        return JSON.parse(params.params)
      }
    },
    handleEnergyTypeFormat (val) {
      switch (val) {
        case 1:
          return '电'
        case 2:
          return '水'
        case 3:
          return '天然气'
        case 4:
          return '柴油'  
      }
    },
    handleModelormat (energyType, val) {
      if (energyType !== 1 && val === 1) {
        return '商业'
      }
      switch (val) {
        case 1:
          return '峰平谷尖'
        case 2:
          return '商业'
        case 3:
          return '阶梯'
      }
    },
    handleThresholdValueFormat (row, column, cellValue, index) {
      return ' ≥ ' + cellValue
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-content {
  width: 100%;
  max-height: 720px;
  box-sizing: border-box;
  overflow: auto;
}

.energy-pricing {
  width: 100%;
  box-sizing: border-box;
}

.title {
  text-align: left;
}

.info {
  text-align: left;
  .info-item {
    margin: 16px;
    box-sizing: border-box;
    padding: 0 24px;
    .item-text-header {
      padding: 8px 0;
      font-size: 16px;
      font-weight: bold;
    }
    .item-text-second {
      padding: 8px 0;
      box-sizing: border-box;
      padding-left: 64px;
    }
    .item-text-three {
      padding: 8px 0;
      box-sizing: border-box;
      padding-left: 64px;
    }
    p.item-text-four:first-of-type {
      margin-top: -32px;
    }
    .item-text-four {
      &:first-of-type {
        margin-top: -32px;
      }
      padding: 8px 0;
      box-sizing: border-box;
      padding-left: 120px;
    }
  }
}
</style>
